const MAX_INVITE_EMAILS = 50;

export function parseInviteEmailsInput(raw: string): string[] {
  const emails = raw
    .split(/[,;\n]+/)
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  return [...new Set(emails)];
}

export function formatInviteEmailsForInput(emails: string[]): string {
  return emails.join(", ");
}

export { MAX_INVITE_EMAILS };
